<template>
  <ckeditor
      v-model="content"
      :editor="editor"
      :config="editorConfig"
      @ready="editorReady"
      class="form-control"
  ></ckeditor>
</template>

<script>
import {ClassicEditor} from "@ckeditor/ckeditor5-editor-classic";
import {Heading} from "@ckeditor/ckeditor5-heading";
import {Essentials} from "@ckeditor/ckeditor5-essentials";
import {Bold, Italic} from "@ckeditor/ckeditor5-basic-styles";
import {Link} from "@ckeditor/ckeditor5-link";
import {Paragraph} from "@ckeditor/ckeditor5-paragraph";
import {List} from "@ckeditor/ckeditor5-list";
import {Table, TableToolbar,  TableProperties,
  TableCellProperties} from "@ckeditor/ckeditor5-table";
import MyUploadAdapter from './MyUploadAdapter.js';
import {Image, ImageToolbar, ImageInsert, ImageResize, ImageCaption, ImageStyle} from '@ckeditor/ckeditor5-image';
import {Font} from "@ckeditor/ckeditor5-font";
import {Alignment} from "@ckeditor/ckeditor5-alignment";
export default {
  name: "CkEditor",
  props: {
    value: {
      type: String,
      default: '',
    },
    isTh: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      content: this.value ?? "",
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          Heading,
          Essentials,
          Bold,
          Italic,
          Link,
          Paragraph,
          List,
          Table,
          TableToolbar,
          TableProperties,
          TableCellProperties,
          Image,
          ImageInsert,
          ImageToolbar,
          ImageResize,
          ImageCaption,
          ImageStyle,
          Font,
          Alignment
        ],
        extraPlugins: [ MyUploadAdapter ],
        licenseKey: 'GPL',
        image: {
          toolbar: ['imageStyle:alignBlockLeft','imageStyle:block','imageStyle:alignBlockRight','|','resizeImage', 'toggleImageCaption', 'imageTextAlternative'],
          resizeUnit: '%',
          resizeOptions: [{
            name: 'resizeImage:original',
            value: null
          },
            {
              name: 'resizeImage:50',
              value: '50'
            },
            {
              name: 'resizeImage:75',
              value: '75'
            },
            {
              name: 'resizeImage:100',
              value: '100'
            }
          ]
        },
        styles: [
          'alignBlockLeft', 'block', 'alignBlockRight'
        ],
        fontFamily: {
          options: [
            'default',
            'Sarabun, sans-serif',
            'Sarabun Bold, sans-serif',
            'Arial, Helvetica, sans-serif',
            'Courier New, Courier, monospace',
            'Georgia, serif',
            'Lucida Sans Unicode, Lucida Grande, sans-serif',
            'Tahoma, Geneva, sans-serif',
            'Times New Roman, Times, serif',
            'Trebuchet MS, Helvetica, sans-serif',
            'Verdana, Geneva, sans-serif',
          ]
        },
        toolbar: {
          items: [
            'heading',
            'bold',
            'italic',
            'link',
            'undo',
            'redo',
            'numberedList',
            'bulletedList',
            'insertImage',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            'alignment',
            'insertTable'
          ]
        },
        table: {
          contentToolbar: [
            'tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties', 'tableProperties'
          ]
        }
      },
      ready: false,
      tempValue: '',
    }
  },
  watch: {
    value(newVal) {
      if (this.ready && newVal !== this.content) {
        this.content = newVal;
      }
    },
    content(newVal) {
      this.$emit('setContent', newVal, this.isTh);
    },
  },
  methods: {
    editorReady() {
      this.ready = true
      this.content = this.value
    }
  }
}
</script>

